import './jquery-3.7.1.min.js';
import './jquery.switcher.min';
import 'jquery-lazy';
import './bootstrap.bundle.min.js';
import './bootstrap-datetimepicker.min.js';
import '../plugins/select2/js/select2.min.js';
import '../plugins/slick/slick.js';
// import './validation.js';
import './select2.min';
import './theme-script.js';
import '../plugins/ion-rangeslider/js/ion.rangeSlider.min.js';
import '../plugins/ion-rangeslider/js/custom-rangeslider.js'
import '../plugins/theia-sticky-sidebar/ResizeSensor.js'
import '../plugins/theia-sticky-sidebar/theia-sticky-sidebar.js';
import '../js/jquery.waypoints.js';
import Sortable from 'sortablejs';

// Drag-to-reorder on non-Vue pages (chat profile photos).
window.Sortable = Sortable;
import '../js/jquery.counterup.min.js';

import '../js/owl.carousel.min.js';
import './script.js';
import './htmx';
import './response-targets';
import './stories';
import Alpine from 'alpinejs'
import ajax from '@imacrayon/alpine-ajax'
import Modal from 'bootstrap/js/dist/modal';

window.bootstrap = { Modal }; // expose globally

window.jquery = window.$ = window.jQuery = require('jquery');
window.Alpine = Alpine
Alpine.plugin(ajax)
Alpine.start();

window.shuffleArray = function (array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
        [array[i], array[j]] = [array[j], array[i]]; // swap elements
    }
    return array;
}

window.toggleSlide = function() {
    const widget = document.getElementById('backToListWidget');
    console.log(widget);
    // add it to the parent .back-to-list

    const backToListElement = widget.closest('.back-to-list');

    if (backToListElement.classList.contains('slide-left')) {
        backToListElement.classList.remove('slide-left');
    } else {
        backToListElement.classList.add('slide-left');
    }
}

$('.back-to-list-text').on('click', function() {
    const href = $(this).data('href');
    if (href) {
        window.location.href = href;
    }
});

window.addEventListener('load', () => {
    $("img.lazy").Lazy();
});

window.applyCheckboxes = function () {
    $('.jtoggler').jtoggler();
};

function formatState (state) {
    if (!state.id) {
        return state.text;
    }
    var $state = $(
        '<span><img src="' + $(state.element).data('flag') + '" class="img-flag" /> <span style="position: relative; top: 1px; left: 3px;">' + state.text + '</span></span>'
    );
    return $state;
};

window.applySelect2Languages = function (el) {
    $(el).select2({
        // minimumResultsForSearch: 10,
        width: '300px',
        // theme: 'bootstrap-5',
        placeholder: $(el).data('placeholder') || 'Select an option',
        allowClear: true,
        templateResult: formatState
    }).on('change', function (e) {
        const selectedValue = $(this).val(); // Get the selected value
        if (selectedValue) {
            const url = new URL(window.location.href);
            url.searchParams.set('language', selectedValue); // Set the query parameter
            window.location.href = url.toString(); // Refresh the page with the new URL
        } else {
            const url = new URL(window.location.href);
            url.search = ''; // Clear all query parameters
            window.location.href = url.toString();
        }
    });
    $(el).show();
};

// Select2 with a round flag in the list and in the chosen value. Options
// carry data-flag="<image url>". Used by the chat profile and partner search.
function formatFlagOption (state) {
    if (!state.id) {
        return state.text;
    }
    var flag = $(state.element).data('flag');
    if (!flag) {
        return state.text;
    }
    return $('<span class="flag-option"><img src="' + flag + '" class="flag-option__img" alt="" /><span></span></span>')
        .find('span').text(state.text).end();
};

window.applySelect2Flags = function (el) {
    $(el).select2({
        width: '100%',
        placeholder: $(el).data('placeholder') || 'Select an option',
        // data-allow-clear="false" hides the clear button; otherwise optional selects get one.
        allowClear: $(el).data('allow-clear') !== undefined ? !!$(el).data('allow-clear') : !$(el).prop('required'),
        templateResult: formatFlagOption,
        templateSelection: formatFlagOption,
    });
};

window.applySelect2 = function (el) {
    $(el).select2({
        // minimumResultsForSearch: 10,
        // width: '300px',
        // theme: 'bootstrap-5',
        placeholder: $(el).data('placeholder') || 'Select an option',
        allowClear: true,
    });
    $(el).hide();
};

window.applyCheckboxes();

$('.language-settings').css('visibility', 'visible');

window.openContact = function () {
    setTimeout(() => {
        $.magnificPopup.open({
            mainClass: 'my-mfp-zoom-in',
            items: {
                src: '#modal-info'
            },
            type: 'inline'
        });
    } , 100);
}


const refreshStatuses = [
    401, // Unauthorized
    403, // Forbidden
    419, // Page Expired
    429, // Too Many Requests
]

document.body.addEventListener('htmx:afterRequest', function(evt) {
    if (evt.detail.failed) {
        if (refreshStatuses.includes(evt.detail.xhr.status)) {
            window.location.reload();
        }
    }
});

function updateDateTime() {
    const now = new Date();

    // Get date string (e.g., "July 27, 2025")
    const dateString = now.toLocaleDateString(undefined, {
        weekday: 'long',  // e.g., "Sunday"
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    // Get time string (e.g., "14:22:10")
    const timeString = now.toLocaleTimeString();

    document.getElementById('date').textContent = dateString + ' - ';
    document.getElementById('clock').textContent = timeString;
}

setInterval(updateDateTime, 1000);
updateDateTime(); // initial call
